import { render, staticRenderFns } from "./settingsCategory.vue?vue&type=template&id=bc6b7ed2&"
import script from "./settingsCategory.vue?vue&type=script&lang=js&"
export * from "./settingsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports